import { Middleware } from "../middleware";
import { format, parse } from 'date-fns'

const api = () => new Middleware().method("GET").append(`/odin/mitre`);

export default {
  getMitreMatrix (filter) {
    return new Middleware()
      .method('GET')
      .append(`/odin/mitre/`)
      .params(filter)
      .build()
      .then(({ data }) => {
        const tactics = data.map( item => {
          const skills = item.skills.map((skill, order) => {
            const subSkills = skill.subSkills.map((subSkill, index) => {
              return {
                ...subSkill,
                order: index
              }
            })
            return { 
              ...skill, 
              subSkills,
              order,
              isOpen: false, 
            }
          })
          return {
            id: item.tacticKey,
            title: item.tacticName,
            countTechniques: item.skills?.length ?? 0,
            skills
          }
        
        })
        return tactics
      })  
  },
  getMitreTechnique (id = '', tactic_id, order_subtechnique, hasSubSkill) {
    const endpoint = {
      technique: `/odin/mitre/skill/${id}`,
      subtechnique: `/odin/mitre/sub-skill/${id}`,
    }
    
    return new Middleware()
      .method('GET')
      .append(order_subtechnique || hasSubSkill ? endpoint.subtechnique : endpoint.technique)
      .build()
      .then(({ data }) => {
        data.updatedAt = data.updatedAt ? data.updatedAt : data.createdAt
        const platforms = data.platforms.map(platform => {
          return { text: platform.name, value: platform.idPlatform }
        })
        const tactic = data.tactics?.find(x => {
          return x.tacticKey === tactic_id
        }) ?? { }
        const createdAt = parse(data.createdAt, 'dd/MM/yyyy HH:mm:ss', new Date())
        const updatedAt = parse(data.updatedAt, 'dd/MM/yyyy HH:mm:ss', new Date())
        return {
          ...data,
          subSkills: data.mitreSubSkills,
          id: order_subtechnique ? data.idSubSkill : data.idSkill,
          tactic: { text: tactic.tacticName, value: tactic.tacticKey },
          order: tactic.order,
          platforms,
          createdAt: format(createdAt, 'dd/MM/yyyy'),
          updatedAt: format(updatedAt, 'dd/MM/yyyy'),
        }
      })  
  },
  getMitreTechniqueRules (id = '', order_subtechnique, hasSubSkill, filter) {
    const endpoint = {
      technique: `/odin/mitre/${id}/documentations`,
      subtechnique: `/odin/mitre/sub-skill/${id}/documentations`,
    }
    
    return new Middleware()
      .method('GET')
      .append(order_subtechnique || hasSubSkill ? endpoint.subtechnique : endpoint.technique)
      .params(filter)
      .build()
      .then(({ data }) =>  data)
  },
  putSkillOrder (tactic_id, list_skill_order) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/mitre/update/order?tactic=${tactic_id}`)
      .setData(list_skill_order)
      .build()
  },
  putSubSkillOrder (list_sub_skill_order) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/mitre/sub-skill/update/order`)
      .setData(list_sub_skill_order)
      .build()
  },
  getMitreTechniqueIncidents (id = '', order_subtechnique, hasSubSkill, filter) {
    const endpoint = {
      technique: `/odin/mitre/skill/${id}/incidents`,
      subtechnique: `/odin/mitre/sub-skill/${id}/incidents`,
    }

    return new Middleware()
      .method('GET')
      .append(order_subtechnique || hasSubSkill ? endpoint.subtechnique : endpoint.technique)
      .params(filter)
      .build()
      .then(({ data }) => data )
  },
  getMitreTechniqueIncident () { //id_incident = ''
    return Promise.resolve({

    
    
    })
  },
  getMitreSubTechnique (id = '', tactic_id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/mitre/${id}`)
      .build()
      .then(({ data }) => {
        const platforms = data.platforms.map(platform => {
          return { text: platform.name, value: platform.idPlatform }
        })
        const tactic = data.tactics.find(x => {
          return x.tactic === tactic_id
        }) ?? {}
        const createdAt = parse(data.createdAt, 'dd/MM/yyyy hh:mm:ss', new Date())
        const updatedAt = parse(data.createdAt, 'dd/MM/yyyy hh:mm:ss', new Date())
        return {
          ...data,
          tactic: { text: tactic.tactic, value: tactic.tactic },
          order: tactic.order,
          platforms,
          createdAt: format(createdAt, 'dd/MM/yyyy'),
          updatedAt: format(updatedAt, 'dd/MM/yyyy'),
        }
      })  
  },
  deleteMitreId (id, type) {
    const append = {
      'skill': `/odin/mitre/skill/${id}`,
      'sub-skill': `/odin/mitre/sub-skill/${id}`
    }
    return new Middleware()
      .method('DELETE')
      .append(append[type])
      .build() 
  },
  getListOrder (tactic_id) {
    if (tactic_id === undefined) {
      return Promise.resolve([{ text: 'Carregando', value: 1 }])
    }
    return new Middleware()
      .method('GET')
      .append(`/odin/mitre/orders/${tactic_id}`)
      .build()
      .then( response => {
        return response.data.map( item => {
          return { text: item, value: item}
        })
      })
  },
  getListAboveThan (tactic_id) {
    if (tactic_id === undefined) return Promise.resolve([])
    return new Middleware()
      .method('GET')
      .append('/odin/mitre/list')
      .params({
        tactic: tactic_id      
      })
      .build()
      .then( ({ data }) => {
        return data.map( item => {
          return { text: item.name, value: item.idSkill}
        })
      })
  },
  getListIDSubtechnique (id_technique) {
    if (id_technique === undefined) return Promise.resolve([])
    return new Middleware()
      .method('GET')
      .append(`/odin/mitre/orders/skill/${id_technique}`)
      .build()
      .then( ({ data }) => {
        return data.map( item => {
          return { text: item, value: item}
        })
      })
  },
  getListPlatforms () {
    return new Middleware()
      .method('GET')
      .append('/odin/mitre/platforms')
      .build()
      .then( response => {
        return response.data.map( item => {
          return { text: item.name, value: item.idPlatform}
        })
      })
  },
  getListTactics () {
    return new Middleware()
      .method('GET')
      .append('/odin/mitre/tactics')
      .build()
      .then( ({ data }) => {
        return Object.entries(data).map( ([value, text]) => {
          return { value, text }
        })
      })
  },
  getListRequiredPermissions () {
    return new Middleware()
      .method('GET')
      .append('/odin/mitre/permissions')
      .build()
      .then( ({ data }) => {

        return Object.entries(data).map( ([value, text]) => {
          return { text, value }
        })
      })
  },
  getSkills(filter) {
    if (filter) {
      return api()
        .params({
          findBy: filter.search,
          page: filter.page,
          size: filter.size,
        })
        .build();
    }
    return api().build();
  },
  addOdinMitreSkill (data) {
    return new Middleware()
      .method('POST')
      .append('/odin/mitre')
      .setData({ 
        idMitre: data.id, 
        ...data,
        id: undefined
      })
      .build()
      .then( ({ data}) =>  data)
  },
  addOdinMitreSubSkill (data) {
    return new Middleware()
      .method('POST')
      .append('/odin/mitre/sub-skill')
      .setData({ 
        idSkill: data.id, 
        ...data,
        id: undefined
      })
      .build()
      .then( ({ data}) =>  data)
  },
  putOdinMitreSkill (data, { idSkill }) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/mitre/skill/${idSkill}`)
      .setData({ 
        idMitre: data.id, 
        ...data,
        id: undefined
      })
      .build()
      .then( ({ data}) =>  data)
  },
  putOdinMitreSubSkill (data, { idSubSkill }) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/mitre/sub-skill/${idSubSkill}`)
      .setData({ 
        idSkill: data.id, 
        ...data,
        id: undefined
      })
      .build()
      .then( ({ data}) =>  data)
  }
};
